import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import RegularFopView from '../../components/fopViews/RegularFopView';

import { isCitrusAdEnabled } from 'apps/analytics/utils/citrusAd';
import { CRITEO_ADS_BETA_FEATURE } from 'apps/analytics/constants';

export default withRouter(connect(state => ({
  analyticsDataBasketItems: state.basket.items,
  isCitrusAdAnalyticsEnabled: isCitrusAdEnabled(state.user.betaFeatures),
  isCriteoAdEnabled: state.user.betaFeatures.includes(CRITEO_ADS_BETA_FEATURE),
}))(RegularFopView));

